"use strict";
import OrderOneUp from 'emun.shopping.admin/admin-order-one-up'
import OrderOneUpDetails from 'emun.shopping.admin/admin-order-one-up-details'

const deps = [
    'emun.auth',
    'webutils',
    'webforms',
    'webmodals',
    'ui.router'];

angular.module('emun.shopping.admin', deps)
.component('orderOneUp', new OrderOneUp())
.component('adminOrderOneUp', new OrderOneUp())
.component('orderOneUpDetails', OrderOneUpDetails)
